import React from "react";
import styles from "./ProfilePage.module.css";
import { useNavigate } from "react-router-dom";
import Button from "../../components/common/Button";

export default function ProfileEmptyState() {
  const navigate = useNavigate();

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <h2 className={styles.title}>Seu Perfil Ainda Não Está Completo</h2>
        <p className={styles.text}>
          Para gerar seus insights de personalidade, você precisa responder ao
          questionário. Ele leva apenas alguns minutos e desbloqueia a área de
          perfil da plataforma.
        </p>

        <Button
          className={styles.primaryBtn}
          style={{ marginTop: "2rem", marginBottom: "2rem" }}
          onClick={() => navigate("/personality-quiz")}
        >
          Começar Questionário
        </Button>

        <p className={styles.subtext}>
          Você só precisa fazer isso uma vez. Depois, seus resultados ficarão
          disponíveis aqui.
        </p>
      </div>
    </div>
  );
}
